import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const HowItWorksPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen mt-10">
    <HeadersNonAuth />
    <br />
    <br />
    <section id="how" className="bg-[#0b0d2a] text-white px-6 lg:px-24 py-16 font-sans">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold mb-8">How It Works</h2>

        <h3 className="text-xl font-semibold mb-4">Institutional Intelligence. Retail Simplicity. Fully Automated.</h3>
        <p className="mb-4">
          The Quantum Flo Auto Algo is the culmination of years of development inside our hedge fund and trading research group. It borrows directly from our <strong>systematic trading technology</strong>, the same tools we've used for over two years in our <strong>Weekly Superstars</strong> service — a strategy with a strong public track record, available for review <a href="https://www.jtncgroup.com/trade-history" className="text-cyan-400 underline">here</a>.
        </p>

        <p className="mb-4">
          While Weekly Superstars trades typically hold for up to two weeks, the <strong>Quantum Flo Auto Algo shortens that window significantly</strong> — with trades designed to complete in <strong>less than four days</strong>, often within <strong>one or two days</strong>, and sometimes even <strong>intra-day</strong>. We deliberately <strong>avoid weekend risk</strong>, and in today’s market environment, we believe that <strong>speed and precision</strong> are the best defense against macro uncertainty.
        </p>

        <hr className="my-10 border-gray-600" />

        <h3 className="text-xl font-semibold mb-4">The Process: Three Steps to Precision</h3>
        <p className="mb-4">
          Our core logic is both powerful and battle-tested, drawing from the same predictive frameworks we offer in our <strong>MSI, Market State Indicator</strong> and <strong>PAI, Price Action Indicator</strong>:
        </p>

        <ol className="list-decimal pl-6 space-y-4">
          <li>
            <strong>Predict the Probable Range</strong>
            <p>
              Each day, the algo forecasts the <strong>likely price range</strong> of the market with a confidence level of <strong>70% or higher</strong>. This range acts like a trading “band,” guiding the algorithm on where price is expected to move in the next 24 hours.
            </p>
          </li>

          <li>
            <strong>Follow the Herd (When It Matters)</strong>
            <p>
              Next, the algo analyzes if <strong>herd behavior</strong>, largely driven by where institutional flows are likely to participate in a directional move. This logic is derived from our MSI indicator, which anticipates where sentiment and positioning are aligned to fuel momentum.
            </p>
          </li>

          <li>
            <strong>Strike with Accuracy</strong>
            <p>
              Armed with range and sentiment signals, the algo uses <strong>options market microstructure</strong> to identify <strong>high-probability entry points</strong>—levels that are either <strong>well-supported by buyers or heavily defended by sellers</strong>. The algo will <strong>wait for price to reach these levels</strong> and execute trades accordingly.
            </p>
            <p>
              To exit the position, the same process runs in reverse:
            </p>
            <ul className="list-disc pl-6">
              <li>If herd behavior fades, or</li>
              <li>If price exits the predicted range, the trade is automatically closed preserving gains or minimizing risk.</li>
            </ul>
          </li>
        </ol>

        <hr className="my-10 border-gray-600" />

        <h3 className="text-xl font-semibold mb-4">Complete Automation With Full Control</h3>
        <p className="mb-4">
          Once connected to your brokerage account, Quantum Flo Auto Algo runs in the background: <br />
          <strong>scanning, analyzing, entering, and exiting trades automatically</strong>. You don’t need to do a thing unless you want to.
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li><strong>Pause it.</strong></li>
          <li><strong>Shut it off.</strong></li>
          <li><strong>Take over a trade manually.</strong></li>
        </ul>
        <p className="mb-4">
          You maintain <strong>complete control</strong> at all times via your broker. Quantum Flo simply brings <strong>machine speed and hedge fund logic</strong> to your trading without removing your autonomy.
        </p>

        <p className="font-semibold text-white mt-6">
          No alerts. No guessing. Just institutional-grade logic in real-time, executed on your behalf.
        </p>
      </div>
    </section>
    </div>
  );
};

export default HowItWorksPage;
